import { TaskListBoardPlaceholder } from 'modules/activity/tasklist/components/TaskListBoard/TaskListBoardPlaceholder';
import { SearchTextbox } from '../../../components/SearchTextbox';
import { isMobileAny } from '../../../utils/device';
import { ListFilterListSearchPortal } from '../../list/components/ListFilterListSearch/ListFilterListSearchPortal';
import { ListLayout } from '../../list/components/ListLayout';
import { ListSidebarIndicatorButton } from '../../list/components/ListSidebar/ListSidebarIndicatorButton';
import { ListLoadingPlaceholderBar } from '../../list/listPage/ListLoadingPlaceholder/ListLoadingPlaceholderBar';
import { ListLoadingPlaceholderSidebar } from '../../list/listPage/ListLoadingPlaceholder/ListLoadingPlaceholderSidebar';

function TaskListLoadingPlaceholder() {
	return (
		<ListLayout>
			<ListLoadingPlaceholderBar
				skipTotalItemsCount
				titleCode={8882}
			/>
			<TaskListBoardPlaceholder />
			<ListSidebarIndicatorButton disabled />
			<ListFilterListSearchPortal searchButtonDisabled>
				<SearchTextbox
					size='small'
					className='filterListSearchTextbox'
					disabled
				/>
			</ListFilterListSearchPortal>

			{!isMobileAny && <ListLoadingPlaceholderSidebar />}
		</ListLayout>
	);
}

export { TaskListLoadingPlaceholder };
